import React from 'react'
import NextImage from 'next/image'

import { Button } from '@wartek-id/button-v1'
import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type TDialogPelaksanaanAppealRollbackProps = {
  isOpen: boolean
  isLoading: boolean
  onClose: () => void
  onConfirm: () => void
}
export const DialogPelaksanaanAppealRollback: React.FC<
  TDialogPelaksanaanAppealRollbackProps
> = ({ isOpen, isLoading, onClose, onConfirm }) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      autoFocus={false}
      returnFocus={false}
    >
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <NextImage
            src="/illustrations/img-document-sync-data.png"
            width={84}
            height={84}
          />

          <div className="space-y-1">
            <Text variant="display-sm">Konfirmasi untuk Mengubah Isi</Text>
            <Text color="subdued" variant="body-lg" className="!text-xl">
              Jika lanjut ubah, isi akan menjadi draf dan harus dikirim ulang.
            </Text>
          </div>
          <div className="flex space-x-5">
            <Button
              data-testid="appeal-rollback-back-button"
              disabled={isLoading}
              onClick={onClose}
              color="white"
              size="lg"
            >
              Kembali
            </Button>
            <Button
              onClick={onConfirm}
              color="blue"
              size="lg"
              disabled={isLoading}
              isLoading={isLoading}
            >
              Konfirmasi
            </Button>
          </div>
        </div>
        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}
